// components/UserCardHR/UserCardHR.js
import PropTypes from "prop-types";
import styles from "./UserCardHR.module.css";

const UserCardHR = ({ user, onNameClick, onImageClick }) => {
  return (
    <div className={styles.userCardHr}>
      <div className={styles.innerContent}>
        <div className={styles.profile}>
          <div className={styles.photo}>
            <img
              className={styles.photoIcon}
              loading="lazy"
              alt=""
              src={user.presigned_url || "/default_user_image.png"}
              onClick={onImageClick}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/default_user_image.png";
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className={styles.info}>
            <div className={styles.nameWrap}>
              <div
                className={styles.name}
                onClick={onNameClick}
                style={{ cursor: "pointer", color: "#1890ff" }}
              >
                {user.user_surname} {user.user_name}
              </div>
            </div>
            <div className={styles.jobWrap}>
              <div className={styles.jobTitle}>Должность:</div>
              <div className={styles.jobTitleText}>
                {user.emp_position || "—"}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.detailInfo}>
          <div className={styles.departmentWrap}>
            <div className={styles.jobTitle}>Департамент:</div>
            <div className={styles.departmentText}>
              {user.emp_department || "—"}
            </div>
          </div>
          <div className={styles.detail}>
            <div className={styles.workHour}>
              <div className={styles.hours}>Рабочий день</div>
              <div className={styles.hoursText}>
                {user.start_work_time || "-"} - {user.end_work_time || "-"}
              </div>
            </div>
            <div className={styles.workHour}>
              <div className={styles.hours}>Пол:</div>
              <div className={styles.hoursText}>
                {user.user_gender === "Male" ? "М" : "Ж" || "—"}
              </div>
            </div>
            <div className={styles.workHour}>
              <div className={styles.hours}>Статус:</div>
              <div className={styles.hoursText}>{user.emp_category || "—"}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

UserCardHR.propTypes = {
  user: PropTypes.object.isRequired,
  onNameClick: PropTypes.func.isRequired,
  onImageClick: PropTypes.func.isRequired,
};

export default UserCardHR;
